import { Updater } from 'widgets-for-react'

export type FieldUpdater<t, k extends keyof t> = (u: Updater<t[k]>) => Updater<t>

export const fieldUpdater =
  <t>() =>
  <k extends keyof t>(k: k): FieldUpdater<t, k> =>
  (u: Updater<t[k]>) =>
  (s: t) => ({ ...s, [k]: u(s[k]) })
